<!-- eslint-disable max-len -->
    <template>
  <div class="py-1">
    <transition
      enter-active-class="transition duration-300 ease-out transform"
      enter-class="scale-95 opacity-0"
      enter-to-class="scale-100 opacity-100"
      leave-active-class="transition duration-150 ease-in transform"
      leave-class="scale-100 opacity-100"
      leave-to-class="scale-95 opacity-0"
    >
      <div
        v-if="openPopup"
        class="
          flex
          items-center
          justify-center
          fixed
          left-0
          bottom-0
          w-full
          h-full
          z-50
        "
        style="background-color: #00000099"
      >
        <div class="bg-white rounded-lg w-3/4 md:w-1/3 max-h-95/100">
          <div class="flex flex-col items-start p-5 h-full">
            <section>
              <div class="text-gray-900 font-bold text-lg">
                Edit Details
                <span v-if="changeNameType === 'ALL'"
                  >- {{ changingDetailsMember.length }} Members</span
                >
              </div>
            </section>
            <section v-if="changeNameType !== 'ALL'" class="w-full mt-5">
              <h5 class="mb-3">Full name</h5>
              <input
                type="text"
                ref="name"
                :placeholder="memberName || 'Full name'"
                class="input input-bordered w-full mb-4"
                required
                name="title"
                v-model="memberName"
              />
            </section>
            <section class="w-full">
               <h5 class="mb-3">First name</h5>
              <input
                type="text"
                ref="name"
                :placeholder="memberFirstName"
                class="input input-bordered w-full mb-4"
                required
                name="title"
                v-model="memberFirstName"
              />
            </section>
            <section v-if="changeNameType !== 'ALL'" class="w-full">
              <h5 class="mb-3">Email</h5>
              <input
                type="text"
                ref="name"
                :placeholder="memberEmail || 'Email'"
                class="input input-bordered w-full mb-4"
                required
                name="title"
                v-model="memberEmail "
              />
               <h5 class="mb-3">Notes</h5>
              <textarea
                rows="10"
                type="text"
                ref="name"
                :placeholder="memberNotes || 'Notes'"
                class="input input-bordered w-full"
                style="min-height:150px"
                required
                name="title"
                v-model="memberNotes"
              />
            </section>

            <hr class="w-full my-3" />
            <section class="mt-0 w-full flex justify-center">
              <div class="mr-5">
                <button class="btn btn-primary btn-outline" @click="callback()">
                  cancel
                </button>
              </div>
              <div class="">
                <button class="btn btn-primary" @click="handleChangeName">
                  change
                </button>
              </div>
            </section>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import store from '@/store';
import utils from '@/services/utils';
import userInfo from '@/services/userInfo';

export default {
  name: 'ChangeNameModal',
  layout: 'admin',
  store,
  props: [
    'openPopup',
    'callback',
    'memberId',
    'memberProviderId',
    'previousName',
    'previousEmail',
    'previousFullName',
    'previousNotes',
    'fetchStudentList',
    'changeNameType',
    'enrolled',
    'enrolledStudents',
  ],
  data() {
    return {
      memberFirstName: this.previousName,
      memberName: this.previousFullName,
      memberEmail: this.previousEmail,
      memberNotes: this.previousNotes,
    };
  },
  computed: {
    user() {
      return store.state.user;
    },
    changingDetailsMember() {
      return this.enrolled.filter((data) => data === true);
    },
  },
  watch: {
    previousName(newPreviousName, oldPreviousName) {
      if (newPreviousName !== oldPreviousName) {
        this.memberFirstName = newPreviousName;
      }
    },
    previousFullName(newPreviousName, oldPreviousName) {
      if (newPreviousName !== oldPreviousName) {
        this.memberName = newPreviousName;
      }
    },
    previousEmail(newPreviousName, oldPreviousName) {
      if (newPreviousName !== oldPreviousName) {
        this.memberEmail = newPreviousName;
      }
    },
    previousNotes(newPreviousName, oldPreviousName) {
      if (newPreviousName !== oldPreviousName) {
        this.memberNotes = newPreviousName;
      }
    },
    openPopup(val) {
      if (val) {
        this.focusInput();
      }
    },
  },
  methods: {
    async handleChangeName() {
      try {
        store.commit('toggleLoading', true);
        this.callback();
        const selectedStudents = [];
        for (let i = 0; i < this.enrolledStudents.length; i += 1) {
          if (this.enrolled[i] === true) {
            selectedStudents.push(this.enrolledStudents[i]);
          }
        }
        const body = {
          memberId:
            this.changeNameType === 'SINGLE'
              ? this.memberId
              : selectedStudents.map(({ userRefId }) => userRefId),
          memberProviderId:
            this.changeNameType === 'SINGLE'
              ? this.memberProviderId
              : selectedStudents.map(({ providerID }) => providerID),
          memberFirstName: this.memberFirstName,
          changeNameType: this.changeNameType,
          memberName: this.memberName,
          memberEmail: this.memberEmail,
          memberNotes: this.memberNotes,
        };
        let userId = this.user.uid;
        if (this.$route.query.userId) {
          userId = this.$route.query.userId;
        }
        const response = await userInfo.changeFirstName(userId, body);
        this.fetchStudentList();
        store.commit('toggleLoading', false);
        utils.setStatusMsg(this, response.message);
      } catch (err) {
        store.commit('toggleLoading', false);
        console.log('changeFirstName err', err);
      }
    },
    focusInput() {
      this.$nextTick(() => {
        this.$refs.name.focus();
      });
    },
  },
};
</script>

<style>
.top-right {
  top: 1.5rem;
  right: 4rem;
}
</style>
